export default "__VITE_ASSET__CFwI1ZT$__"